var exports = {
  "kL": "ForgotPasswordPage.module__container___ZWxZd2",
  "DD": "ForgotPasswordPage.module__title___ZWxZd2",
  "h_": "ForgotPasswordPage.module__description___ZWxZd2",
  "Zd": "ForgotPasswordPage.module__form___ZWxZd2",
  "qr": "ForgotPasswordPage.module__footer___ZWxZd2",
  "nf": "ForgotPasswordPage.module__link___ZWxZd2",
  "P9": "ForgotPasswordPage.module__primaryLink___ZWxZd2",
  "kn": "ForgotPasswordPage.module__footerLabel___ZWxZd2",
};

module.exports = exports;
